export enum AssetType {
    Tractor = 0,
    Trailer = 1,
    BoxTruck = 2
}

export const AssetTypeMetadata = {
    '0': {
        display: 'Tractor',
        value: 0
    },
    '1': {
        display: 'Trailer',
        value: 1
    },
    '2': {
        display: 'Box Truck',
        value: 2
    }
};
